import React, { Component } from "react";
import { Card, Form, Button, Row, Col } from "react-bootstrap";
import axios from "axios";
import CommonToast from "../Toaster/CommonToast";
import CommonLoader from "../loaderComponent/CommonLoader";
import Select from 'react-select';
export default class WorkOrderAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      projects: [],
      billingAddresses: [],
      dispatchAddresses: [],
      items: [],
      woNumber: "",
      woDate: "",
      customerId: "",
      projectId: "",
      billingAddressId: "",
      dispatchAddressId: "",
      status: "draft",
      customersDispatchAddress: [],
      customersBillingAddress: [],
      poItems: [
        {
          serialNumber: 1,
          //labourId: "",
          hsnCode: "",
          uom: "",
          quantity: "",
          rate: "",
          taxableValue: 0,
          gstValue: 0,
          totalValue: 0,
          pendingQuantity: 0,
        },
      ],
      loading: false,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      color: '',
      isEdit: false,
      poId: null,
      showLoading: true
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.fetchCustomers();
    await this.fetchItems();

    const poId = this.props.match?.params?.id;
    if (poId) {
      this.setState({ isEdit: true, poId });
      await this.fetchPurchaseOrder(poId);

      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    } else {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    }
  }

  // componentDidMount() {
  //   this.fetchCustomers();
  //   this.fetchItems().then(() => {
  //     const poId = this.props.match?.params?.id;
  //     if (poId) {
  //       this.setState({ isEdit: true, poId });
  //       this.fetchPurchaseOrder(poId);
  //     }
  //   });
  //   setTimeout(() => {
  //     this.setState({ loading: false })
  //   }, 1000)
  // }

  fetchCustomersBillingAddress = async (customerId) => {
    try {
      const res = await axios.get(`/address/${customerId}/c/b`);
      this.setState({ customersBillingAddress: res.data });
    } catch (error) {
      console.error("Error fetching billing address:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchCustomersDispatchAddress = async (customerId) => {
    try {
      const res = await axios.get(`/address/${customerId}/c/d`);
      this.setState({ customersDispatchAddress: res.data });
    } catch (error) {
      console.error("Error fetching dispatch address:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchCustomers = async () => {
    try {
      const res = await axios.get("/customer");
      this.setState({ customers: res.data });
    } catch (error) {
      console.error("Failed to fetch customers:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };

  fetchProjects = async (customerId) => {
    try {
      const res = await axios.get(`/project/customer/${customerId}`);
      this.setState({ projects: res.data });
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchAddresses = async (customerId) => {
    try {
      const res = await axios.get(`/address?customerId=${customerId}`);
      const billingAddresses = res.data.filter((a) => a.type === "billing");
      const dispatchAddresses = res.data.filter((a) => a.type === "dispatch");

      this.setState({
        billingAddresses,
        dispatchAddresses,
      });
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchItems = async () => {
    try {
      const res = await axios.get("/labours");
      this.setState({ items: res.data });
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchPurchaseOrder = async (id) => {
    // this.setState({ loading: true });
    try {
      const res = await axios.get(`/workorders/${id}`);
      const po = res.data;
      // Set form data from PO
      this.setState({
        woNumber: po.woNumber,
        woDate: po.woDate,
        customerId: po.customerId,
        projectId: po.projectId,
        billingAddressId: po.billingAddressId,
        dispatchAddressId: po.dispatchAddressId,
        status: po.status,
        poItems: po.items.map((item) => ({
          serialNumber: item.serialNumber,
          labourid: item?.labour?.labourid,
          hsnCode: item.hsnCode,
          uom: item?.uomData?.name || item.uom,
          quantity: item.quantity,
          rate: item.rate,
          taxableValue: item.taxableValue,
          gstValue: item.gstValue,
          totalValue: item.totalValue,
          pendingQuantity: item.pendingQuantity,
        })),
      });
      // Wait for all dependent data to finish
      await Promise.all([
        this.fetchProjects(po.customerId),
        this.fetchItems(),
        this.fetchCustomersBillingAddress(po.customerId),
        this.fetchCustomersDispatchAddress(po.customerId),
      ]);
      this.setState({ showLoading: false })
    } catch (error) {
      console.error("Error fetching PO:", error);
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    }
  };


  handleCustomerChange = (e) => {
    const customerId = e.target.value;
    this.setState(
      {
        customerId,
        projectId: "",
        billingAddressId: "",
        dispatchAddressId: "",
        projects: [],
        billingAddresses: [],
        dispatchAddresses: [],
      },
      () => {
        if (customerId) {
          this.fetchProjects(customerId);
          // this.fetchAddresses(customerId);
          this.fetchCustomersBillingAddress(customerId);
          this.fetchCustomersDispatchAddress(customerId);
        }
      }
    );
  };

  handleProjectChange = (e) => {
    this.setState({ projectId: e.target.value });
  };

  handleBillingAddressChange = (e) => {
    this.setState({ billingAddressId: e.target.value });
  };

  handleDispatchAddressChange = (e) => {
    this.setState({ dispatchAddressId: e.target.value });
  };

  handlePoNumberChange = (e) => {
    this.setState({ woNumber: e.target.value });
  };

  handlePoDateChange = (e) => {
    this.setState({ woDate: e.target.value });
  };

  handlePoItemChange = (index, field, value) => {

    const poItems = [...this.state.poItems];
    poItems[index][field] = value;

    if (field === "labourid") {
      //const selectedItem = this.state.items.find((i) => i.labourid === parseInt(value));
      const selectedItem = this.state.items.find((i) => i.labourid === parseInt(value));
      if (selectedItem) {
        poItems[index].hsnCode = selectedItem.hsnCode || "";
        poItems[index].uom = selectedItem.uomData?.name || ""; // Store UOM name
      } else {
        poItems[index].hsnCode = "";
        poItems[index].uom = "";
      }
    }

    if (field === "quantity" || field === "rate" || field === "labourid") {
      const quantity = parseFloat(poItems[index].quantity) || 0;
      const rate = parseFloat(poItems[index].rate) || 0;
      const taxableValue = quantity * rate;
      const gstValue = taxableValue * 0.18;
      const totalValue = taxableValue + gstValue;
      poItems[index].taxableValue = taxableValue;
      poItems[index].gstValue = gstValue;
      poItems[index].totalValue = totalValue;
      poItems[index].pendingQuantity = quantity; // Initially pending quantity equals quantity
    }

    this.setState({ poItems });
  };

  addRow = () => {
    const poItems = [...this.state.poItems];
    poItems.push({
      serialNumber: poItems.length + 1,
      labourid: "",
      hsnCode: "",
      uom: "",
      quantity: "",
      rate: "",
      taxableValue: 0,
      gstValue: 0,
      totalValue: 0,
      pendingQuantity: 0,
    });
    this.setState({ poItems });
  };

  removeRow = (index) => {
    const poItems = [...this.state.poItems];
    poItems.splice(index, 1);
    // Recalculate serial numbers
    poItems.forEach((item, idx) => {
      item.serialNumber = idx + 1;
    });
    this.setState({ poItems });
  };

  validateForm = () => {
    const errors = {};
    if (!this.state.customerId) errors.customerId = "Customer is required";
    if (!this.state.projectId) errors.projectId = "Project is required";
    if (!this.state.billingAddressId) errors.billingAddressId = "Billing address is required";
    if (!this.state.dispatchAddressId) errors.dispatchAddressId = "Dispatch address is required";
    // if (!this.state.woNumber.trim()) errors.woNumber = "PO Number is required";
    const woNumber = this.state.woNumber.trim();
    // const poNumberRegex = /^\d{1,6}$/;

    // if (!woNumber) {
    //   errors.woNumber = "PO Number is required";
    // } else if (!poNumberRegex.test(woNumber)) {
    //   errors.woNumber = "PO Number must be 1 to 6 digits only";
    // }
    const poNumberRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~ ]{1,30}$/;

    if (!woNumber) {
      errors.woNumber = "WO Number is required";
    } else if (!poNumberRegex.test(woNumber)) {
      errors.woNumber = "WO Number must be 1 to 30 characters and can include letters, numbers, and special characters";
    }
    if (!this.state.woDate) errors.woDate = "WO Date is required";
    this.state.poItems.forEach((item, index) => {
      if (!item.labourid) errors[`labourid_${index}`] = "Labour is required";
      if (!item.quantity < 0) errors[`quantity_${index}`] = "Quantity must be greater than or equal to 0";
      if (!item.rate || item.rate <= 0) errors[`rate_${index}`] = "Rate must be greater than 0";
    });
    return errors;
  };

  onSubmit = (e) => {

    //this.changeStatus("draft");

    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, showToast: true, toastMessage: "Please fix validation errors", toastVariant: "danger", color: 'red' });
      return;
    }
    this.setState({ loading: true });
    const {
      customerId,
      projectId,
      billingAddressId,
      dispatchAddressId,
      woNumber,
      woDate,
      status,
      poItems,
      isEdit,
      poId,
    } = this.state;

    const payload = {
      customerId,
      projectId,
      billingAddressId,
      dispatchAddressId,
      woNumber,
      woDate,
      status,
      items: poItems,
    };

    const request = isEdit
      ? axios.put(`/workorders/${poId}`, payload)
      : axios.post("/workorders", payload);

    request
      .then(() => {
        this.setState({
          showToast: true,
          toastMessage: `Work Order ${isEdit ? "updated" : "created"} successfully!`,
          toastVariant: "success",
          color: 'green'
        });


        if (!isEdit) {
          this.setState({
            customerId: "",
            projectId: "",
            billingAddressId: "",
            dispatchAddressId: "",
            woNumber: "",
            woDate: "",
            poItems: [
              {
                serialNumber: 1,
                labourid: "",
                hsnCode: "",
                uom: "",
                quantity: "",
                rate: "",
                taxableValue: 0,
                gstValue: 0,
                totalValue: 0,
                pendingQuantity: 0,
              },
            ],
            errors: {},
          });
          setTimeout(() => {
            this.setState({ loading: false })
          }, 2000)
        }
        setTimeout(() => {
          this.setState({ loading: false })
          this.workOrderList()
        }, 600)
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error saving Work Order",
          toastVariant: "danger",
          color: 'red'
        });
        setTimeout(() => {
          this.setState({ loading: false })
        }, 1000)
      });
  };

  changeStatus = (newStatus) => {
    const errors = this.validateForm();
    this.setState({ loading: true });
    const payload = {
      customerId: Number(this.state.customerId),
      projectId: Number(this.state.projectId),
      billingAddressId: Number(this.state.billingAddressId),
      dispatchAddressId: Number(this.state.dispatchAddressId),
      woNumber: this.state.woNumber,
      woDate: this.state.woDate,
      status: newStatus,
      items: this.state.poItems.map(item => ({
        ...item,
        labourid: Number(item.labourid),
        quantity: Number(item.quantity),
        rate: Number(item.rate),
        taxableValue: Number(item.taxableValue),
        gstValue: Number(item.gstValue),
        totalValue: Number(item.totalValue),
        pendingQuantity: Number(item.pendingQuantity),
      })),
    };

    // Determine if we're creating (POST) or updating (PUT)
    const isEdit = this.state.isEdit && this.state.poId;
    const request = isEdit
      ? axios.put(`/workorders/${this.state.poId}`, payload)
      : axios.post("/workorders", payload);

    request
      .then((response) => {
        // If new work order, capture the ID from response
        const newState = {
          status: newStatus,
          showToast: true,
          toastMessage: `Work Order ${isEdit ? 'updated' : 'created'} successfully!`,
          toastVariant: "success",
          color: 'green'
        };
        // this.workOrderList()
        if (!isEdit) {
          newState.isEdit = true;
          newState.poId = response.data.id; // Assuming response contains new ID
        }
        this.setState(newState);
        setTimeout(() => {
          this.setState({ loading: false })
          this.workOrderList()
        }, 600)
      })

      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error saving Work Order",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  workOrderList = () => {
    this.props.history.push('/work-order')
  }

  render() {
    const {
      customers,
      projects,
      billingAddresses,
      dispatchAddresses,
      items,
      woNumber,
      woDate,
      customerId,
      projectId,
      billingAddressId,
      dispatchAddressId,
      status,
      poItems,
      errors,
      loading,
      isEdit,
    } = this.state;



    return (
      <div>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back">
                  <b>
                    {this.props?.location?.pathname?.includes('purchaseOrder-view')
                      ? "View"
                      : isEdit
                        ? "Update"
                        : "Add"} Work Order
                  </b>
                  <span style={{ cursor: 'pointer' }} onClick={() => this.workOrderList()}>
                    <i className="far fa-arrow-alt-circle-right"> Work Order List</i>
                  </span>
                </div>
              </Card.Header>
              <Card.Body style={{ marginBottom: '40px' }}>
                <Form onSubmit={this.onSubmit}>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formCustomer">
                        <Form.Label className="required">Customer</Form.Label>
                        <Form.Control
                          as="select"

                          value={customerId}
                          className="form-select"
                          onChange={this.handleCustomerChange}
                          isInvalid={!!errors?.customerId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Customer</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.customerId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control
                          as="select"
                          value={projectId}
                          className="form-select"
                          onChange={this.handleProjectChange}
                          isInvalid={!!errors?.projectId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.projectId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formPoNumber">
                        <Form.Label className="required">WO Number</Form.Label>
                        <Form.Control
                          type="text"
                          value={woNumber}
                          placeholder="Enter WO number"
                          onChange={this.handlePoNumberChange}
                          isInvalid={!!errors?.woNumber}
                          disabled={status === "pending"}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.woNumber}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formPoDate">
                        <Form.Label className="required">WO Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={woDate}
                          onChange={this.handlePoDateChange}
                          isInvalid={!!errors?.woDate}
                          disabled={status === "pending"}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.woDate}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="formBillingAddress">
                        <Form.Label className="required">Billing Address</Form.Label>
                        <Form.Control
                          as="select"
                          value={billingAddressId}
                          className="form-select"
                          onChange={this.handleBillingAddressChange}
                          isInvalid={!!errors?.billingAddressId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Billing Address</option>
                          {this.state.customersBillingAddress.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.address}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.billingAddressId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formDispatchAddress">
                        <Form.Label className="required">Dispatch Address</Form.Label>
                        <Form.Control
                          as="select"
                          value={dispatchAddressId}
                          className="form-select"
                          onChange={this.handleDispatchAddressChange}
                          isInvalid={!!errors?.dispatchAddressId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Dispatch Address</option>
                          {this.state.customersDispatchAddress.map((a) => (
                            // {dispatchAddresses.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.address}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.dispatchAddressId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>Labour</h5>
                  {poItems.map((item, index) => (
                    <Card key={index} className="mb-3">
                      <Card.Body>
                        <Row>
                          <Col md={2}>
                            <Form.Group controlId={`formSno${index}`}>
                              <Form.Label>S.No</Form.Label>
                              <Form.Control type="text" value={item.serialNumber} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formItem${index}`}>
                              <Form.Label className="required">Labour</Form.Label>
                              <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                options={items.map((i) => ({ value: i.labourid, label: i.name }))}
                                value={
                                  items.find((i) => i.labourid === item.labourid)
                                    ? {
                                      value: item.labourid,
                                      label: items.find((i) => i.labourid === item.labourid).name,
                                    }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  this.handlePoItemChange(index, "labourid", selectedOption?.value || "")
                                }
                                isDisabled={status === "pending"}
                                placeholder="Select Labour"
                                isSearchable={true} // <== this ensures the search bar shows up
                              />
                              {errors?.[`labourid_${index}`] && (
                                <div className="invalid-feedback d-block">
                                  {errors[`labourid_${index}`]}
                                </div>
                              )}
                            </Form.Group>

                            {/* <Form.Group controlId={`formItem${index}`}>
                              <Form.Label className="required">Labour</Form.Label>
                              <Form.Control
                                as="select"
                                value={item.labourid}
                                className="form-select"
                                onChange={(e) => this.handlePoItemChange(index, "labourid", e.target.value)}
                                isInvalid={!!errors?.[`labourid_${index}`]}
                                disabled={status === "pending"}
                              >
                                <option value="">Select Labour
                                </option>
                                {items.map((i) => (
                                  <option key={i.labourid} value={i.labourid}>
                                    {i.name}
                                  </option>
                                ))}
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">{errors?.[`labourid_${index}`]}</Form.Control.Feedback>
                            </Form.Group> */}
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formHsnCode${index}`}>
                              <Form.Label>HSN Code</Form.Label>
                              <Form.Control type="text" value={item.hsnCode} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formUom${index}`}>
                              <Form.Label>UOM</Form.Label>
                              <Form.Control type="text" value={item.uom} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formQuantity${index}`}>
                              <Form.Label className="required">Quantity</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.quantity}
                                placeholder="Enter quantity"
                                onChange={(e) => this.handlePoItemChange(index, "quantity", e.target.value)}
                                isInvalid={!!errors?.[`quantity_${index}`]}
                                disabled={status === "pending"}
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`quantity_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                        </Row>
                        <Row>
                          <Col md={2}>
                            <Form.Group controlId={`formRate${index}`}>
                              <Form.Label className="required">Rate</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.rate}
                                placeholder="Enter rate"
                                onChange={(e) => this.handlePoItemChange(index, "rate", e.target.value)}
                                isInvalid={!!errors?.[`rate_${index}`]}
                                disabled={status === "pending"}
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`rate_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formTaxableValue${index}`}>
                              <Form.Label>Taxable Value</Form.Label>
                              <Form.Control type="number" value={item.taxableValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formGstValue${index}`}>
                              <Form.Label>GST (18%)</Form.Label>
                              <Form.Control type="number" value={item.gstValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formTotalValue${index}`}>
                              <Form.Label>Total Value</Form.Label>
                              <Form.Control type="number" value={item.totalValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formPendingQuantity${index}`}>
                              <Form.Label>Pending Quantity</Form.Label>
                              <Form.Control type="number" value={item.pendingQuantity} readOnly />
                            </Form.Group>
                          </Col>
                        </Row>
                        {status !== "pending" && (
                          <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm mt-3 custom-add-button-cancel" onClick={() => this.removeRow(index)} >
                            Remove
                          </Button>
                        )}
                      </Card.Body>
                    </Card>
                  ))}
                  {status !== "pending" && (
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.addRow} >
                      Add Row
                    </Button>
                  )}
                  <hr />
                  {/* <p className="total-value">Total Value of All Items: ₹ <span className="amount-value">{poItems.reduce((sum, item) => sum + (parseFloat(item.totalValue) || 0), 0).toFixed(2)}</span></p> */}
                  <div>
                    <span className="status-btn">
                      {status !== "pending" && (
                        <Button variant='primary' className="px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={(e) => this.onSubmit(e)} >
                          Save as Draft
                        </Button>
                      )}
                    </span>
                    <span className="status-btn">
                      {status === "draft" && (
                        <Button variant='warning' className="px-4 py-2 rounded-pill shadow-sm custom-add-button-generate btn btn-primary" onClick={() => this.changeStatus("pending")} >
                          Mark as Pending
                        </Button>
                      )}
                    </span>
                    <span>
                      <Button variant='danger' className=" px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={() => this.workOrderList()} >
                        Cancel
                      </Button>
                    </span>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader >
      </div>
    );
  }
}
